import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

// ** Fetch Clients
export const getClients = createAsyncThunk('appClients/getClients', async (params) => {
  const response = await axios.get('/api/clients', { params })
  return response.data
})

// ** Fetch single Client
export const getSingleClients = createAsyncThunk('appClients/getSingleClients', async (id) => {
  const response = await axios.get(`/api/clients/${id}`)
  return response.data
})

// ** Add Client
export const addClient = createAsyncThunk(
  'appClients/addClient', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/api/clients', { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

export const updateClient = createAsyncThunk(
  'appClients/updateClient', 
  async ({ id, ...data}, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/clients/${id}`, { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// ** Delete User
export const deleteClient = createAsyncThunk('appClients/deleteClient', async (id, { getState, dispatch }) => {
  const response = await axios.delete(`/api/clients/${id}`)
  dispatch(getClients(getState().user.params)) // Refresh user list after deletion
  return response.data
})

export const appClientsSlice = createSlice({
  name: 'appClients',
  initialState: {
    singleData: {},   // Data for a single Client
    data: [],         // Data for a list of Clients
    total: 0,
    params: {},
    allData: [],      // (Optional) Store all Client data if needed
    status: 'idle',
    message:null,
    errors: null
  },
  reducers: {
    resetSingleClient: (state) => {
      state.singleData = {}; // Reset single Client data
    },
    resetStateIdele: (state) => {
      state.status = 'idle'; // Reset single Client data
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple Clients
    builder
      .addCase(getClients.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getClients.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getClients.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    // ** Add Client
    builder
      .addCase(addClient.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(addClient.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(addClient.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors =  action.payload.errors
      })

    builder
      .addCase(updateClient.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(updateClient.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(updateClient.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = action.payload.errors
      })

    // ** Delete Client
    builder
      .addCase(deleteClient.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(deleteClient.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(deleteClient.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    // ** Fetch Single Client
    builder
      .addCase(getSingleClients.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getSingleClients.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.singleData = action.payload.data
      })
      .addCase(getSingleClients.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })
  }
})

export const { resetSingleClient, resetStateIdele } = appClientsSlice.actions;



export default appClientsSlice.reducer
